import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { ShopConfig } from '@/shared/typings/types/guide';

const initialState: ShopConfig = {
  _init: false,
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(_state, { payload }: PayloadAction<Omit<ShopConfig, '_init'>>) {
      return { ...payload, _init: true };
    },
    updateConfig(state, { payload }: PayloadAction<Partial<Omit<ShopConfig, '_init'>>>) {
      return { ...state, ...payload };
    },
    resetConfigInit() {
      return initialState;
    },
  },
});

export const {
  setConfig,
  updateConfig,
  resetConfigInit,
} = configSlice.actions;

export const getConfig = (state: RootState): ShopConfig => state.config;
export const getConfigInit = (state: RootState): boolean => state.config._init;

export default configSlice.reducer;
